import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const scheduleAssignmentRegime = api(async function scheduleAssignmentRegime({ regimeId }) {
    return query(
        gql`
            query GetScheduleAssignmentRegime($regimeId: String!) {
                scheduleAssignmentRegime(regimeId: $regimeId)
            }
        `,
        { regimeId },
        { returns: "scheduleAssignmentRegime" }
    )
})
